import { Vue, Options } from 'vue-class-component';
import { getModule } from 'vuex-module-decorators';
import user from '@/store/user';
import { ServiceBanner } from '@/services/ServiceBanner';
import { TUser } from '@/types/TUser';

@Options({
    name: 'AdminBanner'
})
export default class AdminBanner extends Vue {
    declare public $refs: any;
    public userStore = getModule(user);

    public appid = 0;
    public isClickable = 'n';
    public linkUrl = '';
    public openInNewTab = 'y';

    public currentImageBase64 = '';   // image already stored on the server
    public pickedImagePreview = '';   // preview of a newly picked file
    public pickedImageFile: File | null = null;
    public saving = false;

    get user(): TUser {
        return this.userStore.user;
    }

    // image shown in the preview: the freshly picked one wins over the stored one
    get showBanner(): string {
        return this.pickedImagePreview || this.currentImageBase64;
    }

    public created() {
        this.loadBanner();
    }

    public loadBanner() {
        ServiceBanner.getBannerAdmin().then(response => {
            if (response.status === 'success' && response.banner) {
                this.appid = response.banner.appid;
                this.isClickable = response.banner.isClickable || 'n';
                this.linkUrl = response.banner.linkUrl || '';
                this.openInNewTab = response.banner.openInNewTab || 'y';
                this.currentImageBase64 = response.banner.imageBase64 || '';
            }
        });
    }

    public onImageAdded(files: readonly File[]) {
        const file = files && files.length ? files[0] : null;
        if (!file) {
            return;
        }
        this.pickedImageFile = file;
        const reader = new FileReader();
        reader.onload = (e: any) => {
            this.pickedImagePreview = e.target.result;
        };
        reader.readAsDataURL(file);
    }

    public isValidLink(link: string): boolean {
        const l = (link || '').trim();
        if (!l) {
            return false;
        }
        if (l.startsWith('/') && !l.startsWith('//')) {
            return true; // internal app route
        }
        return /^https?:\/\//i.test(l);
    }

    public onSubmit() {
        if (this.isClickable === 'y' && !this.isValidLink(this.linkUrl)) {
            this.$q.notify({ type: 'negative', message: 'Introduceti un link valid (https://... sau o ruta interna /...).' });
            return;
        }
        if (this.appid === 0 && !this.pickedImageFile) {
            this.$q.notify({ type: 'negative', message: 'Incarcati o imagine pentru banner.' });
            return;
        }

        this.saving = true;
        ServiceBanner.saveBanner({
            isClickable: this.isClickable,
            linkUrl: this.isClickable === 'y' ? this.linkUrl.trim() : '',
            openInNewTab: this.openInNewTab
        }).then(async response => {
            if (response.status !== 'success') {
                this.$q.notify({ type: 'negative', message: response.message || 'Eroare la salvarea setarilor.' });
                this.saving = false;
                return;
            }
            this.appid = response.appid;

            if (this.pickedImageFile) {
                const up = await ServiceBanner.uploadBannerImage(this.appid, this.pickedImageFile);
                if (up.status !== 'success') {
                    this.$q.notify({ type: 'negative', message: up.message || 'Eroare la incarcarea imaginii.' });
                    this.saving = false;
                    return;
                }
            }

            this.$q.notify({ type: 'positive', message: 'Banner salvat cu succes!' });
            this.pickedImageFile = null;
            this.pickedImagePreview = '';
            if (this.$refs.bannerUploader) {
                this.$refs.bannerUploader.reset();
            }
            this.saving = false;
            this.loadBanner();
        }).catch(() => {
            this.saving = false;
        });
    }
}
